import {
  BRAND_LIST,
  CATEGORY_LIST,
  DEPARTMENT_LIST,
  DESIGNATION_LIST,
  EMPLOYEE_LIST,
  LOCATION_LIST,
  MASTERDATA,
  MODEL_LIST,
  VENDOR_LIST,
} from '@constants/internal-route.constant'
import {IAppRoutes} from '@interface/common.interface'
import {guard} from './route-guard'

// Gated by the ERPBOI_ITAM catalog seeded in portal (module "IT Asset Management - ITAM" >
// group "Master Data" > these 6 features). Gating is app-agnostic (matches by feature
// URL), so this works regardless of REACT_APP_CODE.
export const MasterdataRoutes: IAppRoutes = {
  link: MASTERDATA,
  childrens: [
    {
      link: CATEGORY_LIST,
      element: guard(() => import('@modules/masterdata/Category'), [CATEGORY_LIST]),
    },
    {
      link: BRAND_LIST,
      element: guard(() => import('@modules/masterdata/Brand'), [BRAND_LIST]),
    },
    {
      link: MODEL_LIST,
      element: guard(() => import('@modules/masterdata/Model'), [MODEL_LIST]),
    },
    {
      link: VENDOR_LIST,
      element: guard(() => import('@modules/masterdata/Vendor'), [VENDOR_LIST]),
    },
    {
      link: DEPARTMENT_LIST,
      element: guard(() => import('@modules/masterdata/Department'), [DEPARTMENT_LIST]),
    },
    {
      link: DESIGNATION_LIST,
      element: guard(() => import('@modules/masterdata/Designation'), [DESIGNATION_LIST]),
    },
    {
      link: LOCATION_LIST,
      element: guard(() => import('@modules/masterdata/Location'), [LOCATION_LIST]),
    },
    {
      link: EMPLOYEE_LIST,
      element: guard(() => import('@modules/masterdata/Employee'), [EMPLOYEE_LIST]),
    },
  ],
}
